<template>
  <div
    class="pay pk-payment-page"
    :style="{
      backgroundImage: 'url(' + img + ')',
    }"
  >
    <navheader
      v-if="false"
      :showNav="showNav"
      :yidongmenu="yidongmenu"
      :openHongbao="openHongbao"
    ></navheader>
    <div class="pay-warp">
      <!-- <div class="pay-title">充值披萨币</div> -->
      <div class="pay-hint">
        <div class="pay-hint-left">
          <strong>账户充值</strong>
          <span>充值披萨币用于打开箱子、箱子战斗和站内玩法</span>
          <!-- <span>每日累积充值最高为 2000</span> -->
          <!-- <img src="../assets/img/money.png" />
          <span>，每日零点重置</span> -->
        </div>
        <div class="pay-hint-actions">
          <button type="button" @click="concact()">充值帮助</button>
          <button type="button" class="payBill" @click="goToBill()">我的账单</button>
        </div>
        <div class="tMsg">
          服务不满意，请先联系客服，如问题仍未解决，请<span @click="concact()"
            >联系客服>></span
          >
        </div>
      </div>
      <section class="identity-panel" :class="'identity-status-' + identityInfo.status">
        <div class="identity-mark">ID</div>
        <div class="identity-copy">
          <span>身份验证</span>
          <strong>{{ identityInfo.status_name }}</strong>
          <p>{{ identitySummary }}</p>
        </div>
        <button v-if="!isLoggedIn()" @click="openIdentity">登录后认证</button>
        <button v-else-if="identityInfo.can_submit" @click="openIdentity">
          {{ identityInfo.status == 3 ? "重新提交" : "立即认证" }}
        </button>
        <button v-else class="identity-view-button" :disabled="identityDetailLoading" @click="openIdentityDetail">查看实名</button>
      </section>
      <div class="pay-ment">
        <p v-if="!identityVerified" class="pk-identity-recharge-lock">{{ rechargeNotice }}</p>
        <p v-if="!testMode" class="pk-payment-channel-status">{{ paymentChannelNotice }}</p>
        <el-tabs tab-position="top" v-model="payType">
          <el-tab-pane label="支付宝" name="alipay">
            <div class="ment-one">
              <div></div>
            </div>
            <div class="ment-two">
              <img style="height: 50px" src="../assets/img/zhifubao.png" />
              <span>{{ paymentAvailable ? "在线支付" : "支付宝支付通道筹备中" }}</span>
            </div>
            <div class="ment-three" v-if="firstGiveValidate">
              <span class="ment-three"
                >限时活动：<span class="time">{{
                  firstGive.start_time ? firstGive.start_time : "即日起"
                }}</span>
                <span class="time">至{{ firstGive.end_time }}截止</span>
                {{ firstGive.desc }}</span
              >
              {{ paymentAvailable ? "充值将在10分钟内到账" : "在线支付通道暂未开放" }}
            </div>
            <div class="ment-three" v-else-if="ordinaryValidate">
              <span
                v-if="ordinaryActivity.start_time && ordinaryActivity.end_time"
              >
                活动时间 {{ ordinaryActivity.start_time }} 至
                {{ ordinaryActivity.end_time }}
              </span>
              <span
                v-if="ordinaryActivity.start_time && !ordinaryActivity.end_time"
              >
                活动时间 {{ ordinaryActivity.start_time }} 起
              </span>
              <span
                v-if="!ordinaryActivity.start_time && ordinaryActivity.end_time"
              >
                截至 {{ ordinaryActivity.end_time }}
              </span>
              <span
                v-if="
                  !ordinaryActivity.start_time && !ordinaryActivity.end_time
                "
              >
                即日起
              </span>
              <span
                v-if="ordinaryActivity.money > 0 && ordinaryActivity.limit > 0"
              >
                单笔充值{{ ordinaryActivity.money }}(含)以上,{{
                  ordinaryActivity.limit
                }}(含)以下+送{{ ordinaryActivity.billie }}%,
              </span>
              <span
                v-if="ordinaryActivity.money == 0 && ordinaryActivity.limit > 0"
              >
                单笔充值{{ ordinaryActivity.limit }}(含)以下+送{{
                  ordinaryActivity.billie
                }}%,
              </span>
              <span
                v-if="ordinaryActivity.money > 0 && ordinaryActivity.limit == 0"
              >
                单笔充值{{ ordinaryActivity.money }}(含)以上+送{{
                  ordinaryActivity.billie
                }}%,
              </span>
              <span
                v-if="
                  ordinaryActivity.money == 0 && ordinaryActivity.limit == 0
                "
              >
                单笔充值+送{{ ordinaryActivity.billie }}%,
              </span>
              <span>{{ paymentAvailable ? "充值将在10分钟内到账" : "在线支付通道暂未开放" }}</span>
              <div
                v-if="
                  ordinaryActivity.money == 0 && ordinaryActivity.limit == 0
                "
                style="color: red"
              >
                注意：支付成功后请返回支付页面，等待完成！
              </div>
            </div>
            <div class="ment-three" v-else>{{ paymentAvailable ? "充值将在10分钟内到账" : "在线支付通道暂未开放" }}</div>
            <div class="ment-list" v-if="showNav">
              <ul>
                <li
                  v-for="(item, index) in list"
                  :key="index"
                  @click="zhifuMoney(index)"
                  :class="item.id ? '' : 'list-li'"
                >
                  <div class="ment-state" v-if="item.state"></div>

                  <div
                    class="give"
                    v-if="firstGiveValidate && item.is_first_give && is_new"
                  >
                    首充多送{{
                      ((Number(item.money) * firstGive.billie) / 100).toFixed(
                        2
                      )
                    }} 披萨币
                  </div>
                  <div v-else>
                    <div class="give" v-if="item.billieState">
                      多送{{
                        ((Number(item.money) * item.billie) / 100).toFixed(2)
                      }}
                    </div>
                  </div>

                  <div class="package-name" v-if="item.id">{{ item.package_name }}</div>
                  <div class="package-gift" v-if="item.id && Number(item.gift_amount) > 0">
                    加赠 {{ item.gift_amount }} 披萨币
                  </div>
                  <!-- <div class="list-top" :class="'img-r'+index" v-if="item.img && (list.length/(index+1) != 1)"> -->
                  <div class="list-top" v-if="item.id">
                    <img :src="item.img" />
                  </div>
                  <div class="list-warp" v-if="item.id">
                    <div class="list-con">{{ item.money }}</div>
                    <div class="list-bot">≈ ￥ {{ item.rmb }}</div>
                    <div class="package-desc">{{ item.package_desc }}</div>
                  </div>

                  <div class="list-warp" v-if="!item.id">
                    <div
                      class="list-top list-top1"
                      :class="!item.id ? 'no-p-1' : ''"
                    >
                      其他数量
                    </div>
                    <div class="list-input">
                      <span class="list-span1" @click="remInput">-</span>
                      <el-input
                        class="input"
                        @input="getInput"
                        type="number"
                        v-model="item.money"
                      />
                      <span class="list-span2" @click="addInput">+</span>
                    </div>
                    <div class="list-bot">≈ ￥ {{ item.rmb }}</div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="ment-listm" v-else>
              <ul>
                <li
                  v-for="(item, index) in list"
                  :key="index"
                  @click="zhifuMoney(index)"
                  :class="item.id ? '' : 'list-li'"
                >
                  <div class="ment-state" v-if="item.state"></div>

                  <div
                    class="give"
                    v-if="firstGiveValidate && item.is_first_give && is_new"
                  >
                    首充多送{{
                      ((Number(item.money) * firstGive.billie) / 100).toFixed(
                        2
                      )
                    }} 披萨币
                  </div>
                  <div v-else>
                    <div class="give" v-if="item.billieState">
                      多送{{
                        ((Number(item.money) * item.billie) / 100).toFixed(2)
                      }}
                    </div>
                  </div>

                  <div class="package-name" v-if="item.id">{{ item.package_name }}</div>
                  <div class="package-gift" v-if="item.id && Number(item.gift_amount) > 0">
                    加赠 {{ item.gift_amount }} 披萨币
                  </div>
                  <!-- <div class="list-top" :class="'img-r'+index" v-if="item.img && (list.length/(index+1) != 1)"> -->
                  <div class="list-top" v-if="item.id">
                    <img :src="item.img" />
                  </div>
                  <div class="list-warp" v-if="item.id">
                    <div class="list-con">{{ item.money }}</div>
                    <div class="list-bot">≈ ￥ {{ item.rmb }}</div>
                    <div class="package-desc">{{ item.package_desc }}</div>
                  </div>

                  <div class="list-warp" v-if="!item.id">
                    <div
                      class="list-top list-top1"
                      :class="!item.id ? 'no-p-1' : ''"
                    >
                      其他数量
                    </div>
                    <div class="list-input">
                      <span class="list-span1" @click="remInput">-</span>
                      <el-input
                        class="input"
                        @input="getInput"
                        type="number"
                        v-model="item.money"
                      />
                      <span class="list-span2" @click="addInput">+</span>
                    </div>
                    <div class="list-bot">≈ ￥ {{ item.rmb }}</div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="ment-btn">
              <el-button
                class="el-btn"
                :disabled="loading || !rechargeAvailable"
                :style="{ 'background-color': loading || !rechargeAvailable ? '#5b6070' : '#e9b10e' }"
                @click="payInfo('zhifubao')"
                ><i v-if="loading" class="el-icon-loading"></i>立即充值
              </el-button>
              <!-- <el-button class="el-btn" :disabled="loading"
								:style="{ 'background-color': loading ? '#949493' : '#e9b10e' }" ><i v-if="loading" class="el-icon-loading"></i>支付宝维护中  请用微信付款
							</el-button> -->
            </div>
          </el-tab-pane>

          <el-tab-pane v-if="false" label="微信充值" name="wechat">
            <div class="ment-one">
              <div></div>
            </div>
            <div class="ment-two">
              <img style="height: 50px" src="../assets/img/weixin.png" />
              <span>{{ paymentAvailable ? "微信支付" : "微信支付通道筹备中" }}</span>
            </div>
            <div class="ment-three" v-if="firstGiveValidate">
              <span class="ment-three"
                >限时活动：<span class="time">{{
                  firstGive.start_time ? firstGive.start_time : "即日起"
                }}</span>
                <span class="time">至{{ firstGive.end_time }}截止</span>
                {{ firstGive.desc }}</span
              >
              {{ paymentAvailable ? "充值将在10分钟内到账" : "在线支付通道暂未开放" }}
            </div>
            <div class="ment-three" v-else-if="ordinaryValidate">
              <span
                v-if="ordinaryActivity.start_time && ordinaryActivity.end_time"
              >
                活动时间 {{ ordinaryActivity.start_time }} 至
                {{ ordinaryActivity.end_time }}
              </span>
              <span
                v-if="ordinaryActivity.start_time && !ordinaryActivity.end_time"
              >
                活动时间 {{ ordinaryActivity.start_time }} 起
              </span>
              <span
                v-if="!ordinaryActivity.start_time && ordinaryActivity.end_time"
                style="margin-right: 10px"
              >
                截至 {{ ordinaryActivity.end_time }}
              </span>
              <span
                v-if="
                  !ordinaryActivity.start_time && !ordinaryActivity.end_time
                "
              >
                即日起
              </span>
              <span
                v-if="ordinaryActivity.money > 0 && ordinaryActivity.limit > 0"
              >
                单笔充值{{ ordinaryActivity.money }}(含)以上,{{
                  ordinaryActivity.limit
                }}(含)以下+送{{ ordinaryActivity.billie }}%,
              </span>
              <span
                v-if="ordinaryActivity.money == 0 && ordinaryActivity.limit > 0"
              >
                单笔充值{{ ordinaryActivity.limit }}(含)以下+送{{
                  ordinaryActivity.billie
                }}%,
              </span>
              <span
                v-if="ordinaryActivity.money > 0 && ordinaryActivity.limit == 0"
              >
                单笔充值{{ ordinaryActivity.money }}(含)以上+送{{
                  ordinaryActivity.billie
                }}%,
              </span>
              <span
                v-if="
                  ordinaryActivity.money == 0 && ordinaryActivity.limit == 0
                "
              >
                单笔充值+送{{ ordinaryActivity.billie }}%,
              </span>
              {{ paymentAvailable ? "充值将在10分钟内到账" : "在线支付通道暂未开放" }}
            </div>
            <div class="ment-three" v-else>{{ paymentAvailable ? "充值将在10分钟内到账" : "在线支付通道暂未开放" }}</div>
            <div class="ment-list">
              <ul>
                <li
                  v-for="(item, index) in list"
                  :key="index"
                  @click="weixinMoney(index)"
                  :class="item.id ? '' : 'list-li'"
                >
                  <div class="ment-state" v-if="item.state"></div>

                  <div v-if="firstGiveValidate && item.is_first_give && is_new">
                    <div class="give">
                      首充多送{{
                        ((Number(item.money) * firstGive.billie) / 100).toFixed(
                          2
                        )
                      }} 披萨币
                    </div>
                  </div>

                  <div v-else>
                    <div class="give" v-if="item.billieState">
                      多送{{
                        ((Number(item.money) * item.billie) / 100).toFixed(2)
                      }}
                    </div>
                  </div>

                  <div class="package-name" v-if="item.id">{{ item.package_name }}</div>
                  <div class="package-gift" v-if="item.id && Number(item.gift_amount) > 0">
                    加赠 {{ item.gift_amount }} 披萨币
                  </div>
                  <!-- <div class="list-top" :class="'img-r'+index" v-if="item.img && (list.length/(index+1) != 1)"> -->
                  <div class="list-top" v-if="item.id">
                    <img :src="item.img" />
                  </div>
                  <div class="list-warp" v-if="item.id">
                    <div class="list-con">{{ item.money }}</div>
                    <div class="list-bot">≈ ￥ {{ item.rmb }}</div>
                    <div class="package-desc">{{ item.package_desc }}</div>
                  </div>
                  <div class="list-warp" v-if="!item.id">
                    <div
                      class="list-top list-top1"
                      :class="!item.id ? 'no-p-1' : ''"
                    >
                      其他数量
                    </div>
                    <div class="list-input">
                      <span class="list-span1" @click="remInput">-</span>
                      <el-input
                        class="input"
                        @input="getInput"
                        type="number"
                        v-model="item.money"
                      />
                      <span class="list-span2" @click="addInput">+</span>
                    </div>
                    <div class="list-bot">≈ ￥ {{ item.rmb }}</div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="ment-btn">
              <el-button
                class="el-btn"
                :disabled="loading || !rechargeAvailable"
                :style="{ 'background-color': loading || !rechargeAvailable ? '#5b6070' : '#e9b10e' }"
                @click="payInfo('wechat')"
                ><i v-if="loading" class="el-icon-loading"></i
                >立即充值</el-button
              >
            </div>
          </el-tab-pane>

          <el-tab-pane label="cdk" name="cdk">
            <div class="ment-one">
              <div></div>
            </div>
            <div class="ment-two">
              <img style="height: 50px" src="../assets/pizzaking/icon-cdk.svg" />
              <span>cdk</span>
            </div>
            <div class="ment-five"></div>
            <div class="ment-four">
              <span>充值码:</span>
              <input
                style="width: 200px; height: 20px"
                type="text"
                v-model="cdk"
                :disabled="!identityVerified"
              />
            </div>

            <div class="ment-btn">
              <el-button
                class="el-btn"
                @click="getcdk"
                :disabled="loading || !identityVerified"
                :style="{ 'background-color': loading || !identityVerified ? '#949493' : '#e9b10e' }"
                ><i v-if="loading" class="el-icon-loading"></i
                >立即充值</el-button
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="礼品卡" name="gift">
            <div class="ment-one">
              <div></div>
            </div>
            <div class="ment-two gift-card-head">
              <img style="height: 50px" src="../assets/pizzaking/pizza-token.svg" />
              <span>礼品卡充值</span>
            </div>
            <div class="gift-card-panel">
              <p>输入礼品卡卡号与卡密，核销成功后披萨币将立即到账。</p>
              <div class="gift-grid">
                <label>
                  <span>卡号</span>
                  <input type="text" v-model.trim="giftCardNo" :disabled="loading || !identityVerified" placeholder="请输入礼品卡卡号" />
                </label>
                <label>
                  <span>卡密</span>
                  <input type="password" v-model.trim="giftCardSecret" :disabled="loading || !identityVerified" placeholder="请输入礼品卡卡密" />
                </label>
              </div>
              <div class="gift-note">
                <strong>流程说明</strong>
                <span>每张礼品卡仅可核销一次，到账结果以站内账单为准。</span>
              </div>
            </div>
            <div class="ment-btn">
              <el-button
                class="el-btn"
                :disabled="loading || !identityVerified"
                :style="{ 'background-color': loading || !identityVerified ? '#949493' : '#e9b10e' }"
                @click="submitGiftCard"
              >
                <i v-if="loading" class="el-icon-loading"></i>立即核销
              </el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      class="identity-dialog"
      title="实名认证"
      :visible.sync="identityDialog"
      width="520px"
      center
    >
      <div class="identity-form">
        <p>请填写本人真实信息。证件号码会生成校验摘要，并以加密形式保存用于后续快捷支付核验。</p>
        <label>
          <span>真实姓名</span>
          <input v-model.trim="identityForm.real_name" maxlength="30" placeholder="请输入真实姓名" />
        </label>
        <label>
          <span>身份证号码</span>
          <input
            v-model.trim="identityForm.id_card"
            maxlength="18"
            autocomplete="off"
            placeholder="请输入18位身份证号码"
          />
        </label>
        <el-checkbox v-model="identityConsent">
          我确认已年满18周岁，并同意提交以上信息进行人工审核。
        </el-checkbox>
      </div>
      <span slot="footer" class="identity-dialog-footer">
        <el-button @click="identityDialog = false">取消</el-button>
        <el-button type="warning" :loading="identityLoading" @click="submitIdentity">
          提交审核
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="identity-dialog identity-detail-dialog"
      title="实名信息"
      :visible.sync="identityDetailDialog"
      width="520px"
      center
    >
      <div class="identity-detail">
        <div class="identity-detail-status" :class="'status-' + identityDetail.status">
          <span>认证状态</span>
          <strong>{{ identityDetail.status_name || "-" }}</strong>
        </div>
        <dl>
          <div><dt>真实姓名</dt><dd>{{ identityDetail.real_name || "-" }}</dd></div>
          <div><dt>身份证号码</dt><dd>{{ identityDetail.id_card_masked || "-" }}</dd></div>
          <div><dt>提交时间</dt><dd>{{ identityDetail.submit_time || "-" }}</dd></div>
          <div><dt>审核时间</dt><dd>{{ identityDetail.review_time || "-" }}</dd></div>
          <div v-if="identityDetail.review_remark"><dt>审核备注</dt><dd>{{ identityDetail.review_remark }}</dd></div>
        </dl>
      </div>
      <span slot="footer" class="identity-dialog-footer">
        <el-button type="warning" @click="identityDetailDialog = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="identity-dialog payment-identity-dialog"
      title="支付实名核验"
      :visible.sync="paymentIdentityDialog"
      width="520px"
      center
      @closed="resetPaymentIdentity"
    >
      <div class="identity-form">
        <p>支付通道要求本次付款携带实名信息。勾选保存后将加密存储，下次可直接快捷填写。</p>
        <label>
          <span>真实姓名</span>
          <input
            :type="paymentIdentityHidden ? 'password' : 'text'"
            v-model.trim="paymentIdentityForm.real_name"
            maxlength="30"
            autocomplete="off"
            placeholder="请输入已审核的真实姓名"
          />
        </label>
        <label>
          <span>身份证号码</span>
          <input
            :type="paymentIdentityHidden ? 'password' : 'text'"
            v-model.trim="paymentIdentityForm.id_card"
            maxlength="18"
            autocomplete="off"
            placeholder="请输入已审核的18位身份证号码"
          />
        </label>
        <div class="payment-identity-tools">
          <el-checkbox v-model="savePaymentIdentity">保存为快捷实名</el-checkbox>
          <button type="button" @click="paymentIdentityHidden = !paymentIdentityHidden">
            {{ paymentIdentityHidden ? "查看隐藏信息" : "隐藏实名信息" }}
          </button>
        </div>
      </div>
      <span slot="footer" class="identity-dialog-footer">
        <el-button @click="paymentIdentityDialog = false">取消</el-button>
        <el-button type="warning" @click="confirmPaymentIdentity">确认并创建订单</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="payBox"
      width="320px"
      center
      top="5%"
      :before-close="handleClose"
    >
      <div slot="title" class="dialog-title">
        <div>
          <img :src="require('../assets/img/' + payTitleIcon)" />
          <span class="title-text">{{ payTitle }}</span>
        </div>
      </div>
      <div style="min-height: 160px">
        <div id="qrcode" ref="qrcode" style="margin-left: 60px" />
      </div>
      <div class="save-qrcode">
        <el-button type="warning" @click="saveImg">保存二维码</el-button>
        <el-button type="warning" @click="copyToClipboard"
          >复制支付链接</el-button
        >
      </div>
      <div slot="footer">
        <div class="dialog-footer">
          <img src="../assets/img/scan.svg" />
          <div>
            <p>{{ payFooter }}</p>
            <p>{{ payFooterDesc }}</p>
          </div>
        </div>
        <div style="font-size: 14px;line-height:20px;margin-top:20px;">手机端会直接打开支付宝支付页面；如未跳转，可复制链接到支付宝或手机浏览器完成支付</div>
      </div>
    </el-dialog>
    <!-- 2021-8-27 新增 充值提示  -->
    <el-dialog
      class="payinfoBox"
      title="账户充值"
      :visible.sync="payInfoData.flag"
      width="64%"
      center
      top="5%"
    >
      <h3>请阅读以下协议并勾选同意，然后点击按钮前去充值。</h3>
      <div class="">
        <el-checkbox v-model="payInfoData.checked1"
          >1.我满18岁且具备完全行为能力。</el-checkbox
        >
      </div>
      <div>
        <el-checkbox v-model="payInfoData.checked2"
          >2.购买虚拟物品后不可退款或者换货，请在经济承受能力内进行消费。</el-checkbox
        >
      </div>
      <div class="btn-area">
        <el-button type="primary" round @click="checkPayInfo"
          >我知道了</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import navheader from "@/components/navheader.vue";
import Utils from "./../assets/js/util.js";
import { playUiSound } from "@/utils/pizzaSound";

export default {
  components: {
    navheader,
  },
  props: ["yidongmenu", "showNav", "openHongbao", "img"],
  data() {
    return {
      loading: false,
      paymentChannelEnabled: false,
      paymentChannelNotice:
        "在线支付通道筹备中，CDK 与礼品卡兑换通道可正常使用。",
      payTitle: "",
      payTitleIcon: "wechat.svg",
      payFooter: "",
      payFooterDesc: "",
      payBox: false,
      payUrl: "",
      paymentOrderNum: "",
      paymentStatusTimer: null,
      cdk: "",
      giftCardNo: "",
      giftCardSecret: "",
      identityDialog: false,
      identityLoading: false,
      identityConsent: false,
      identityDetailDialog: false,
      identityDetailLoading: false,
      identityDetail: {},
      paymentIdentityDialog: false,
      pendingPaymentType: "",
      paymentIdentityHidden: false,
      paymentIdentitySaved: false,
      savePaymentIdentity: true,
      paymentIdentityForm: {
        real_name: "",
        id_card: "",
      },
      identityForm: {
        real_name: "",
        id_card: "",
      },
      identityInfo: {
        status: 0,
        status_name: "未认证",
        can_submit: 1,
        recharge_allowed: 0,
      },
      payType: "alipay",
      list: [],
      payAmountIcon: require("../assets/pizzaking/pizza-token.svg"),
      payObj: {
        rmb: 0,
        money: 5,
        state: false,
      },
      rmb: 0,
      ratioList: [],
      firstGiveValidate: false,
      ordinaryValidate: false,
      firstGive: {}, //新用户活动
      ordinaryActivity: {}, //非新用户充值活动
      is_new: false, //是否是新用户
      userInfo: {},
      testMode: false,
      testShortcutLoading: false,
      payInfoData: {
        flag: false,
        type: "",
        checked2: false,
        checked1: false,
      }, // 充值提示
    };
  },
  computed: {
    identitySummary() {
      if (this.identityInfo.status == 1) return "实名资料已提交，点击右侧查看认证进度。";
      if (this.identityInfo.status == 2) return "实名信息已隐藏，点击右侧查看认证详情。";
      if (this.identityInfo.status == 3) return "认证未通过，请重新提交实名资料。";
      return "实名认证资料仅用于账号安全与后续合规审核。";
    },
    paymentAvailable() {
      return this.paymentChannelEnabled || this.testMode;
    },
    identityVerified() {
      return this.identityInfo.recharge_allowed == 1;
    },
    rechargeAvailable() {
      return this.paymentAvailable && this.identityVerified;
    },
    rechargeNotice() {
      if (!this.isLoggedIn()) return "登录并完成实名认证后才可充值。";
      if (this.identityInfo.status == 1) return "实名资料正在审核，审核通过后才可充值。";
      if (this.identityInfo.status == 3) return "实名认证未通过，请重新提交并等待审核通过。";
      return "请先完成实名认证，审核通过后才可充值。";
    },
  },
  watch: {
    "$store.state.token"() {
      this.loadIdentity();
      this.loadTestFlow();
    },
  },
  mounted() {
    this.payBox = false;
    this.amountList();
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    this.loadIdentity();
    this.loadTestFlow();
    this.loadPaymentChannel();
    const pendingPaymentOrder = sessionStorage.getItem("pkPendingPaymentOrder");
    if (pendingPaymentOrder && this.isLoggedIn()) {
      this.startPaymentStatusCheck(pendingPaymentOrder);
    }
    window.addEventListener("keydown", this.handleTestPayShortcut);
    console.log(this.userInfo);
    if (this.$route.query.type) {
      this.payType = this.$route.query.type;
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleTestPayShortcut);
    this.clearPaymentStatusCheck();
  },
  methods: {
    isLoggedIn() {
      return Boolean(localStorage.getItem("token"));
    },
    loadIdentity() {
      if (!this.isLoggedIn()) {
        this.identityInfo = {
          status: 0,
          status_name: "未认证",
          can_submit: 1,
          recharge_allowed: 0,
        };
        return;
      }
      this.$axios.post("/index/User/identityInfo", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.identityInfo = res.data.data;
        }
      });
    },
    loadTestFlow() {
      if (!this.isLoggedIn()) {
        this.testMode = false;
        return;
      }
      this.$axios.post("/index/Test_flow/status", this.$qs.stringify({})).then((res) => {
        this.testMode = res.data.status == 1 && res.data.data.can_simulate_recharge == 1;
      });
    },
    loadPaymentChannel() {
      this.$axios.post("/index/Pay/channelStatus", this.$qs.stringify({})).then((res) => {
        const data = res.data || {};
        this.paymentChannelEnabled = data.status == 1 && data.data && data.data.alipay == 1;
        this.paymentChannelNotice = this.paymentChannelEnabled
          ? "支付宝扫码支付已开启，支付成功后余额会自动到账。"
          : "在线支付通道筹备中，CDK 与礼品卡兑换通道可正常使用。";
      });
    },
    startPaymentStatusCheck(orderNum) {
      this.clearPaymentStatusCheck();
      this.paymentOrderNum = orderNum;
      sessionStorage.setItem("pkPendingPaymentOrder", orderNum);
      const checkStatus = () => {
        this.$axios
          .get("/index/Pay/ddcx?on=" + encodeURIComponent(orderNum))
          .then((res) => this.handlePaymentStatusResponse(res, orderNum))
          .catch((error) => this.handlePaymentStatusResponse(error, orderNum));
      };
      checkStatus();
      this.paymentStatusTimer = window.setInterval(checkStatus, 3000);
    },
    handlePaymentStatusResponse(response, orderNum) {
      if (this.paymentOrderNum !== orderNum) {
        return;
      }
      const result = response && response.data
        ? response
        : response && response.response
          ? response.response
          : null;
      if (!result || !result.data || result.data.code != 200) {
        return;
      }
      this.clearPaymentStatusCheck();
      this.handleClose();
      this.showPaymentSuccess();
      this.refreshPaymentBalance();
    },
    showPaymentSuccess() {
      playUiSound("payment");
      this.$message.success("充值成功，披萨币已到账");
      this.$root.$emit("notice-refresh");
    },
    clearPaymentStatusCheck() {
      if (this.paymentStatusTimer) {
        window.clearInterval(this.paymentStatusTimer);
        this.paymentStatusTimer = null;
      }
      this.paymentOrderNum = "";
      sessionStorage.removeItem("pkPendingPaymentOrder");
    },
    refreshPaymentBalance() {
      return this.$axios.post("/index/User/playerInfo", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.syncRedeemBalance(res.data);
          this.amountList();
        }
      });
    },
    renderPaymentQr(qrcode, payUrl) {
      this.$refs.qrcode.innerHTML = "";
      if (qrcode && qrcode.length > 100) {
        const image = document.createElement("img");
        image.width = 160;
        image.height = 160;
        image.alt = "支付宝支付二维码";
        image.src = qrcode.indexOf("data:image") === 0 ? qrcode : "data:image/png;base64," + qrcode;
        this.$refs.qrcode.appendChild(image);
        return;
      }
      new QRCode("qrcode", {
        width: 160,
        height: 160,
        text: qrcode || payUrl,
      });
    },
    handleTestPayShortcut(event) {
      if (!this.testMode || !this.identityVerified || !this.payBox || event.key !== "F8" || this.testShortcutLoading) {
        return;
      }
      event.preventDefault();
      playUiSound("click");
      this.simulatePayment();
    },
    simulatePayment() {
      if (!this.testMode || !this.identityVerified || !this.payBox || this.testShortcutLoading) {
        return;
      }
      const amount = Number(this.selectedMoney());
      const mode = this.payTitleIcon === "alipay.svg" ? "zhifubao" : "weixin";
      this.testShortcutLoading = true;
      this.$axios.post("/index/Test_flow/simulateRecharge", this.$qs.stringify({ amount, mode, order_num: this.paymentOrderNum })).then((res) => {
        this.testShortcutLoading = false;
        if (res.data.status == 1) {
          this.syncRedeemBalance(res.data);
          this.is_new = false;
          this.firstGiveValidate = false;
          this.amountList();
          this.handleClose();
          this.showPaymentSuccess();
          return;
        }
        this.$message.warning(res.data.msg || "支付失败");
      }).catch(() => {
        this.testShortcutLoading = false;
      });
    },
    openIdentity() {
      if (!this.isLoggedIn()) {
        this.$store.commit("getLogin", true);
        this.$message.warning("请先登录");
        return;
      }
      this.identityForm.real_name = "";
      this.identityForm.id_card = "";
      this.identityConsent = false;
      this.identityDialog = true;
    },
    openIdentityDetail() {
      this.identityDetailLoading = true;
      this.$axios.post("/index/User/identityDetail", this.$qs.stringify({})).then((res) => {
        this.identityDetailLoading = false;
        if (res.data.status != 1) {
          this.$message.warning(res.data.msg || "实名信息读取失败");
          return;
        }
        this.identityDetail = res.data.data;
        this.identityDetailDialog = true;
      });
    },
    submitIdentity() {
      if (!this.identityForm.real_name || !this.identityForm.id_card) {
        this.$message.warning("请填写真实姓名和身份证号码");
        return;
      }
      if (!this.identityConsent) {
        this.$message.warning("请先确认实名认证声明");
        return;
      }
      this.identityLoading = true;
      this.$axios
        .post("/index/User/submitIdentity", this.$qs.stringify(this.identityForm))
        .then((res) => {
          this.identityLoading = false;
          if (res.data.status == 1) {
            this.identityInfo = res.data.data;
            this.identityDialog = false;
            this.identityForm.real_name = "";
            this.identityForm.id_card = "";
            this.$message.success(res.data.msg || "认证资料已提交");
          } else {
            this.$message.warning(res.data.msg || "提交失败");
          }
        });
    },
    //充值送多少
    // getRatio() {
    //   this.$axios.get("index/User/giveAboutRecharge").then((res) => {
    //     let data = res.data;
    //     console.log(data);
    //     if (data.status == 1) {
    //       this.ratioList = data.data;
    //     }
    //   });
    // },
    // 跳转到个人账单
    goToBill() {
      this.$router.push({
        path: `/Bill`,
      });
    },
    // 联系客服
    concact() {
      this.$router.push({ path: "/Doubt" });
    },
    //input框
    getInput(value) {
      //  /^(0\.0[1-9]|0\.[1-9]\d|[1-9]\d?(\.\d\d)?|[1-4]\d\d(\.\d\d)?|500)$/
      if (value == "") {
        this.list[6].money = "";
        this.list[6].rmb = 0;
      } else {
        this.list[6].money = value;
        this.list[6].rmb = (value * this.rmb).toFixed(2);
      }
      value = Number(value);

      let money = Number(this.ratioList.money);
      let limit = Number(this.ratioList.limit);
      if (money > 0 && limit > 0) {
        if (value >= money && value <= limit) {
          this.setTrue();
        } else {
          this.setFalse();
        }
      } else if (money == 0 && limit == 0) {
        this.setTrue();
      } else if (money > 0 && limit == 0) {
        console.log(value >= money);
        if (value >= money) {
          this.setTrue();
        } else {
          this.setFalse();
        }
      } else if (money == 0 && limit > 0) {
        if (value <= limit) {
          this.setTrue();
        } else {
          this.setFalse();
        }
      } else {
        this.setFalse();
      }
    },
    CDKInput(e) {
      this.CDK = e.detail.value;
    },
    setTrue() {
      this.list[this.list.length - 1].is_first_give = true;
      this.list[this.list.length - 1].billieState = true;
      this.list[this.list.length - 1].billie = this.ratioList.billie;
    },
    setFalse() {
      this.list[this.list.length - 1].is_first_give = false;
      this.list[this.list.length - 1].billieState = false;
      this.list[this.list.length - 1].billie = 0;
    },
    //加
    addInput() {
      if (this.list[6].money < 5) {
        this.list[6].money = 5.0;
        this.list[6].rmb = 5.0 * this.rmb;
      } else {
        this.list[6].money = (Number(this.list[6].money) + 1).toFixed(2);
        this.list[6].rmb = (this.list[6].money * this.rmb).toFixed(2);
      }
      // console.log(11)
      for (let i = 0; i < this.ratioList.length; i++) {
        if (this.list[6].money >= Number(this.ratioList[i].money)) {
          this.list[6].billie = this.ratioList[i].billie;
          this.list[6].billieState = true;
        } else {
          this.list[6].billieState = false;
        }
      }
    },
    //减
    remInput() {
      if (this.list[6].money <= 5) {
        return;
      }
      this.list[6].money = ((this.list[6].money * 100 - 1 * 100) / 100).toFixed(
        2
      );
      this.list[6].rmb = (this.list[6].money * this.rmb).toFixed(2);
      for (let i = 0; i < this.ratioList.length; i++) {
        if (this.list[6].money >= Number(this.ratioList[i].money)) {
          this.list[6].billie = this.ratioList[i].billie;
          this.list[6].billieState = true;
        } else {
          this.list[6].billieState = false;
        }
      }
    },
    amountList() {
      this.loadChargeInfoList();
      const playerId = localStorage.getItem("id");
      if (!playerId) {
        return;
      }
      let param = {
        player_id: playerId,
      };
      this.$axios
        .post("index/User/giveAboutRecharge", this.$qs.stringify(param))
        .then((res) => {
          let data = res.data;
          this.is_new = data.data.new;
          if (data.status == 1) {
            // this.ratioList = data.data.giveInfo;
            // if(data.data.firstGive){
            //   this.firstGiveValidate = true;
            //   this.firstGive = data.data.firstGive;
            // }
            if (this.is_new) {
              if (data.data.recharge_activity.length > 0) {
                data.data.recharge_activity.forEach((e) => {
                  if (e.type == 1) {
                    this.firstGiveValidate = true;
                    this.ratioList = e;
                    this.firstGive = e;
                  }
                  if (e.type == 2) {
                    this.firstGiveValidate = false;
                    this.ratioList = e;
                    this.ordinaryActivity = e;
                  }
                });
              }
            } else {
              this.firstGiveValidate = false;
              if (data.data.recharge_activity.length > 0) {
                data.data.recharge_activity.forEach((e) => {
                  if (e.type == 2) {
                    this.ratioList = e;
                    this.ordinaryActivity = e;
                  }
                });
              }
            }
          }
          // 获取充值列表
          this.$axios.get("/index/pay/chargeInfoList").then((res) => {
            let data = res.data;
            if (data.status == 1) {
              this.rmb = data.data.exchange_rate;
              this.payObj.rmb = data.data.exchange_rate * 5;
              let list = res.data.data.list.map((item) => ({
                ...item,
                img: this.payAmountIcon,
              }));
              list.push(this.payObj);
              list.forEach(function (item, index) {
                item.state = false;
                if (index == 0) {
                  item.state = true;
                }
              });
              this.list = list;
              // console.log(this.list);
              for (let i = 0; i < this.list.length; i++) {
                let money = Number(this.list[i].money); //当前充值列表金额
                let lower_limit = Number(this.ratioList.money); //后台设定下限
                let upper_limit = Number(this.ratioList.limit); //后台设定上限
                // console.log(money,lower_limit,upper_limit);
                if (lower_limit > 0 && upper_limit > 0) {
                  if (money >= lower_limit && money <= upper_limit) {
                    this.list[i].billie = this.ratioList.billie;
                    this.list[i].billieState = true;
                  }
                }
                if (lower_limit == 0 && upper_limit == 0) {
                  this.list[i].billie = this.ratioList.billie;
                  this.list[i].billieState = true;
                }
                if (lower_limit > 0 && upper_limit == 0) {
                  if (money >= lower_limit) {
                    this.list[i].billie = this.ratioList.billie;
                    this.list[i].billieState = true;
                  }
                }
                if (lower_limit == 0 && upper_limit > 0) {
                  if (money <= upper_limit) {
                    this.list[i].billie = this.ratioList.billie;
                    this.list[i].billieState = true;
                  }
                }
              }
            }
          });
          // console.log(this.ratioList);
          // console.log(this.ordinaryActivity);
          if (!this.empty(this.ordinaryActivity)) {
            this.ordinaryValidate = true;
          }
        });
    },

    //领取红包
    loadChargeInfoList() {
      this.$axios.get("/index/pay/chargeInfoList").then((res) => {
        let data = res.data;
        if (data.status == 1) {
          this.rmb = data.data.exchange_rate;
          this.payObj.rmb = data.data.exchange_rate * 5;
          let list = res.data.data.list.map((item) => ({
            ...item,
            img: this.payAmountIcon,
          }));
          list.push(this.payObj);
          list.forEach(function (item, index) {
            item.state = false;
            if (index == 0) {
              item.state = true;
            }
          });
          this.list = list;
        }
      });
    },

    getcdk() {
      if (!localStorage.getItem("token")) {
        this.$store.commit("getLogin", true);
        this.$message({
          message: "请先登录",
          type: "warning",
        });
        return;
      }
      if (!this.requireVerifiedIdentity()) {
        return;
      }
      if (!this.cdk) {
        this.$message({
          message: "请输入cdk口令",
          type: "warning",
        });
        return;
      }
      // this.hongbaoState1 = false;
      // this.hongbaoState2 = true;
      let param = {
        player_id: this.$store.state.id,
        //cdk_id: this.cdkid,
        password: this.cdk,
      };
      this.loading = true;
      this.$axios
        .post("index/Activity/cdk", this.$qs.stringify(param))
        .then((res) => {
          this.loading = false;
          let data = res.data;
          //  console.log(data);
          if (data.status == 1) {
            //this.hongbaoState1 = false
            //this.hongbaoState2 = true
            //this.hongbaoList()

            this.$message({
              message: data.msg || "cdk兑换成功",

              type: "success",
            });
            this.cdk = "";
            this.syncRedeemBalance(data);
          } else {
            this.$message({
              message: data.msg,
              type: "warning",
            });
          }
        });
    },
    submitGiftCard() {
      if (!localStorage.getItem("token")) {
        this.$store.commit("getLogin", true);
        this.$message({
          message: "请先登录",
          type: "warning",
        });
        return;
      }
      if (!this.giftCardNo || !this.giftCardSecret) {
        this.$message({
          message: "请输入礼品卡卡号和卡密",
          type: "warning",
        });
        return;
      }
      if (!this.requireVerifiedIdentity()) {
        return;
      }
      this.loading = true;
      this.$axios
        .post(
          "index/Activity/cdk",
          this.$qs.stringify({
            card_no: this.giftCardNo,
            card_secret: this.giftCardSecret,
          })
        )
        .then((res) => {
          this.loading = false;
          let data = res.data;
          if (data.status == 1) {
            this.$message({
              message: data.msg || "礼品卡兑换成功",
              type: "success",
            });
            this.giftCardNo = "";
            this.giftCardSecret = "";
            this.syncRedeemBalance(data);
          } else {
            this.$message({
              message: data.msg,
              type: "warning",
            });
          }
        });
    },
    syncRedeemBalance(data) {
      if (data.data && data.data.total_amount !== undefined) {
        this.$store.commit("getMoney", data.data.total_amount);
        Utils.$emit("money", data.data.total_amount);
        let userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
        userInfo.total_amount = data.data.total_amount;
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        this.userInfo = userInfo;
      }
    },

    empty(obj) {
      for (let key in obj) {
        return false; //非空
      }
      return true; //为空
    },
    epayjump() {
      this.$message.warning("当前未开放外部支付跳转，请选择页面内可用的充值方式。");
    },
    selectedMoney() {
      let money = 0;
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].state) {
          money = this.list[i].money;
        }
      }
      return money;
    },
    payInfo(t) {
      if (!this.userInfo || !this.userInfo.id) {
        this.$store.commit("getLogin", true);
        this.$message({
          message: "请先登录",
          type: "warning",
        });
        return;
      }
      if (!this.requireVerifiedIdentity()) {
        return;
      }
      let money = this.selectedMoney();
      if (Number(money) < 5) {
        this.$message({
          message: "充值披萨币不少于 5 个",
          type: "warning",
        });
        return;
      }

      if (this.userInfo.total_amount == "0.00" || money > 199) {
        this.payInfoData.flag = true;
        this.payInfoData.type = t;
      } else {
        this.payAction(t);
      }
    },
    checkPayInfo() {
      if (this.payInfoData.checked1 && this.payInfoData.checked2) {
        if (this.payInfoData.type) {
          this.payInfoData.flag = false;
          this.payAction(this.payInfoData.type);
        }
      } else {
        this.$message.info("请阅读并勾选所有协议");
      }
    },
    payAction(t) {
      if (!this.requireVerifiedIdentity()) {
        return;
      }
      if (!this.paymentAvailable) {
        this.$message.warning("\u5728\u7ebf\u652f\u4ed8\u901a\u9053\u7b79\u5907\u4e2d\uff0c\u8bf7\u5173\u6ce8\u540e\u7eed\u5f00\u653e\u901a\u77e5");
        return;
      }

      this.openPaymentIdentity(t);
    },
    openPaymentIdentity(type) {
      this.pendingPaymentType = type;
      this.paymentIdentityForm.real_name = "";
      this.paymentIdentityForm.id_card = "";
      this.paymentIdentityHidden = false;
      this.paymentIdentitySaved = false;
      this.savePaymentIdentity = true;
      this.$axios.post("/index/User/identityPaymentProfile", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1 && res.data.data) {
          this.paymentIdentityForm.real_name = res.data.data.real_name || "";
          this.paymentIdentityForm.id_card = res.data.data.id_card || "";
          this.paymentIdentitySaved = res.data.data.saved == 1;
          this.paymentIdentityHidden = this.paymentIdentitySaved;
        }
        this.paymentIdentityDialog = true;
      }).catch(() => {
        this.paymentIdentityDialog = true;
      });
    },
    resetPaymentIdentity() {
      this.paymentIdentityForm.real_name = "";
      this.paymentIdentityForm.id_card = "";
      this.pendingPaymentType = "";
      this.paymentIdentityHidden = false;
      this.paymentIdentitySaved = false;
    },
    confirmPaymentIdentity() {
      if (!this.paymentIdentityForm.real_name || !this.paymentIdentityForm.id_card) {
        this.$message.warning("请填写已审核的真实姓名和身份证号码");
        return;
      }
      const type = this.pendingPaymentType;
      const identity = {
        real_name: this.paymentIdentityForm.real_name,
        id_card: this.paymentIdentityForm.id_card.toUpperCase(),
      };
      const start = () => {
        this.paymentIdentityDialog = false;
        this.startOnlinePayment(type, identity);
      };
      if (this.savePaymentIdentity && !this.paymentIdentitySaved) {
        this.$axios.post("/index/User/savePaymentIdentity", this.$qs.stringify(identity)).then((res) => {
          if (res.data.status != 1) {
            this.$message.warning(res.data.msg || "快捷实名保存失败");
            return;
          }
          this.paymentIdentitySaved = true;
          start();
        });
        return;
      }
      start();
    },
    startOnlinePayment(t, identity) {

      // if (this.list[6].money < 5 && this.list[6].state == true) {
      //   this.$message({
      //     message: "充值披萨币不少于 5 个",
      //     type: "warning",
      //   });
      //   return;
      // }

      if (t == "wechat") {
        this.loading = true;
        this.payTitle = "微信支付";
        this.payTitleIcon = "wechat.svg";
        this.payFooter = "请使用微信扫一扫";
        this.payFooterDesc = "扫描二维码完成支付";
        this.pay("weixin", identity);
        return;
      }
      if (t == "jdpay") {
        this.pay("jdpay", identity);
        return;
      }
      this.loading = true;
      this.payTitle = "支付宝支付";
      this.payTitleIcon = "alipay.svg";
      this.payFooter = "请使用支付宝扫一扫";
      this.payFooterDesc = "扫描二维码完成支付";
      this.pay("zhifubao", identity);
    },
    requireVerifiedIdentity() {
      if (this.identityVerified) {
        return true;
      }
      this.$message.warning(this.rechargeNotice);
      return false;
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    copyToClipboard() {
      const input = document.createElement("input");
      input.setAttribute("value", this.payUrl);
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success("复制成功，请在支付宝或手机浏览器中打开支付");
    },
    pay(type, identity) {
      //console.log(this.$store.state.id,this.$store.state.mobile)
      let money = this.selectedMoney();

      let data = {
        mode: type,
        money: money,
        // player_id: this.$store.state.token,
        mobile: this.userInfo.mobile,
        real_name: identity.real_name,
        id_card: identity.id_card,
      };
      this.$axios.post("/index/Pay/recharge", data).then((res) => {
        let data2 = res;
        let data = data2.data;
        if (type == "jdpay") {
          if (this.isMobile()) {
            window.location.href = data.data.payurl;
          } else {
            window.location.href = data.data.pcpayurl;
          }

          this.$router.push({
            path: "/PaymentH5",
            query: {
              money: money,
              qrcode: data2.qrcode,
              payurl: data2.payurl,
            },
          });
          return;
        }

        if (type == "weixin") {
          this.payBox = true;
          this.loading = false;
          this.$nextTick(() => {
            const qrCode = new QRCode("qrcode", {
              width: 160,
              height: 160,
              text: data.data,
            });
            this.payUrl = data.data;
          });
          return;
        }

        if (type == "zhifubao") {
          if (data.status != 1 || !data.data || !data.data.pay_url) {
            this.loading = false;
            this.$message.warning(data.msg || "支付宝支付链接创建失败，请稍后重试");
            return;
          }

          this.payUrl = data.data.pay_url;
          this.startPaymentStatusCheck(data.data.order_num);
          if (this.isMobile()) {
            window.location.href = this.payUrl;
            return;
          }

          this.payBox = true;
          this.loading = false;
          this.$nextTick(() => {
            this.renderPaymentQr(data.data.qrcode, this.payUrl);
          });
          return;
        }

        return;
        if (data2.payurl == undefined) {
          this.$router.push({
            path: "/PaymentH5",
            query: {
              money: money,
              qrcode: data2.qrcode,
            },
          });

          //支付宝
          // this.payBox = true;
          // this.loading = false;
          // this.$nextTick(() => {
          //   const qrCode = new QRCode("qrcode", {
          //     width: 160,
          //     height: 160,
          //     text: data.qrcode,
          //   });
          // });
        } else {
          window.location.href = data2.payurl;
        }

        // if (data.status == 1) {
        // 	//this.$refs.qrcode.innerHTML = "";
        // 	this.payBox = true;
        // 	this.loading = false;
        // 	this.$nextTick(() => {
        // 		const qrCode = new QRCode("qrcode", {
        // 			width: 160,
        // 			height: 160,
        // 			text: res.data.data,
        // 		});
        // 	});
        // }
        // else if (data.status == 2) {
        // 	window.location.href = res.data.data;
        // } else {
        // 	this.$message({
        // 		//message: res.data.msg,
        // 		message: "微信支付维护中，请使用支付宝充值",
        // 		type: "warning",
        // 	})
        // }
      }).catch(() => {
        this.loading = false;
        this.$message.warning("支付请求失败，请检查网络后重试");
      });
    },
    handleClose() {
      this.payBox = false;
      if (this.$refs.qrcode) {
        this.$refs.qrcode.innerHTML = "";
      }
      this.payUrl = "";
      this.clearPaymentStatusCheck();
    },
    saveImg() {
      var canvasData = this.$refs.qrcode.getElementsByTagName("canvas");
      var a = document.createElement("a");
      var event = new MouseEvent("click");
      var imageData = this.$refs.qrcode.getElementsByTagName("img");
      a.href = canvasData[0] ? canvasData[0].toDataURL("image/png") : imageData[0].src;
      a.download = "支付二维码";
      a.dispatchEvent(event);
    },
    weixinMoney(index) {
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].state = false;
      }
      this.list[index].state = true;
    },
    zhifuMoney(index) {
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].state = false;
      }
      this.list[index].state = true;
    },
    epayMoney(index) {
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].state = false;
      }
      this.list[index].state = true;
    },
  },
};
</script>

<style lang="less" scoped>
.payinfoBox {
  /deep/ .el-dialog__title {
    color: #808085;
  }

  /deep/ h3 {
    color: #eaeaea;
    font-weight: normal;
    margin-bottom: 16px;
  }

  /deep/ .el-checkbox {
    color: #17b4ed;
  }

  /deep/ .btn-area {
    text-align: center;
    padding: 16px 0 8px 0;
  }
}

.pay {
  width: 100%;
  background-position: center 0;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  -webkit-background-size: cover;
  /* 兼容Webkit内核浏览器如Chrome和Safari */
  -o-background-size: cover;
  /* 兼容Opera */
  zoom: 1;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
  min-height: 100vh;
  background-color: #1a1c24;
  padding-bottom: 24px;

  &.pk-payment-page {
    min-height: calc(100vh - 198px);
    overflow: visible;
    background-color: transparent;
    background-attachment: scroll;
  }

  .pay-warp {
    padding: 16px;
  }

  .pay-title {
    font-size: 20px;
    color: #c3c3e2;
  }

  .pay-hint {
    margin-top: 10px;
    text-align: right;

    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    .payBill {
      font-size: 20px;
      color: #848492;
      line-height: 1;
      cursor: pointer;
      margin-bottom: 12px;

      :hover {
        color: #e9b10e;
      }
    }

    .tMsg {
      color: #eaeaea;
      font-size: 14px;

      span {
        color: #17b4ed;
        cursor: pointer;
      }
    }

    .pay-hint-left {
      display: flex;
      align-items: center;

      span {
        font-size: 16px;
        color: #848492;
      }

      img {
        width: auto;
        height: 16px;
      }
    }

    .pay-hint-right {
      font-size: 16px;
      color: #848492;
    }

    .pay-hint-right:hover {
      cursor: pointer;
      color: #e9b10e;
    }
  }

  .pay-ment {
    margin-top: 30px;

    .ment-one {
      display: flex;
      justify-content: space-between;

      span {
        color: #17b4ed;
      }

      span:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .ment-two {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 32px;
        color: #c3c3e2;
        margin-left: 15px;
      }

      img {
        // width: 50px;
        height: auto;
      }
    }

    .ment-three {
      margin-top: 20px;
      text-align: center;
      font-size: 16px !important;
      color: #e9b10e;
    }

    .ment-four {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 20px;
        color: #c3c3e2;
        margin-left: 15px;
      }
    }

    .ment-five {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 20px;
        color: #c3c3e2;
        margin-left: 15px;
      }
    }

    .ment-list {
      margin-top: 30px;
      display: flex;
      justify-content: center;

      ul {
        // display: flex;
        //flex-wrap: wrap;

        li {
          float: left;
          width: 145px;
          margin: 5px;
          background-color: #333542;
          height: min-content;
          border-radius: 5px;
          position: relative;

          .list-top {
            text-align: center;
            margin: 35px auto 10px;
            width: 117px;
            height: 117px;
            position: relative;

            img {
              width: 100%;
              max-height: 100%;
              position: absolute;
              bottom: 0;
              left: 0;
            }
          }

          .list-warp {
            display: flex;
            flex-direction: column;
            justify-content: center;
            // padding-left: 40PX;
            // padding-right: 40px;
            padding-bottom: 20px;

            .list-top1 {
              font-size: 14px;
              color: #c3c3e2;
              margin: 60px auto 0;
              height: 68px;
            }

            .list-input {
              padding-left: 10px;
              padding-right: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 20px;
              position: relative;
              z-index: 66;

              .input /deep/ .el-input__inner {
                max-width: 50px;
                padding: 0;
                color: #e9b10e;
                background-color: #333542;
                height: 30px;
                line-height: 30px;
              }

              span {
                font-size: 30px;
                color: #848492;
              }

              .list-span1 {
                margin-right: 20px;
              }

              .list-span2 {
                margin-left: 10px;
              }
            }

            .list-con {
              text-align: center;
              // margin-top: 30px;
              color: #e9b10e;
              font-size: 20px;
            }

            .list-bot {
              text-align: center;
              margin-top: 10px;
              font-size: 14px;
              color: #848492;
              white-space: nowrap;
            }
          }

          .ment-state {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 5px;
            border: 1px solid #e9b10e;
            background-color: rgba(233, 177, 14, 0.1);
          }

          .give {
            position: absolute;
            top: 1px;
            left: 0;
            width: 100%;
            height: 32px;
            line-height: 32px;
            margin-left: 1px;
            background-color: #e9b10e;
            color: #1a1c24;
            font-size: 13px;
            text-align: center;
            border-top-right-radius: 5px;
            border-top-left-radius: 5px;
          }
        }

        .list-li {
          // padding: 40px 20px 20px 20px;
        }

        li:hover {
          cursor: pointer;
        }
      }
    }

    .ment-listm {
      margin-top: 30px;
      display: flex;
      justify-content: center;

      ul {
        // display: flex;
        //flex-wrap: wrap;

        li {
          float: left;
          width: 145px;
          margin: 5px;
          background-color: #333542;
          height: min-content;
          border-radius: 5px;
          position: relative;

          .list-top {
            text-align: center;
            margin: -20px auto 10px;
            width: 77px;
            height: 117px;
            position: relative;

            img {
              width: 100%;
              max-height: 100%;
              position: absolute;
              bottom: 0;
              left: 0;
            }
          }

          .list-warp {
            display: flex;
            flex-direction: column;
            justify-content: center;
            // padding-left: 40PX;
            // padding-right: 40px;
            padding-bottom: 20px;

            .list-top1 {
              font-size: 14px;
              color: #c3c3e2;
              margin: 60px auto 0;
              height: 68px;
            }

            .list-input {
              padding-left: 10px;
              padding-right: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 20px;
              position: relative;
              z-index: 66;

              .input /deep/ .el-input__inner {
                max-width: 50px;
                padding: 0;
                color: #e9b10e;
                background-color: #333542;
                height: 30px;
                line-height: 30px;
              }

              span {
                font-size: 30px;
                color: #848492;
              }

              .list-span1 {
                margin-right: 20px;
              }

              .list-span2 {
                margin-left: 10px;
              }
            }

            .list-con {
              text-align: center;
              // margin-top: 30px;
              color: #e9b10e;
              font-size: 20px;
            }

            .list-bot {
              text-align: center;
              margin-top: 10px;
              font-size: 14px;
              color: #848492;
              white-space: nowrap;
            }
          }

          .ment-state {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 5px;
            border: 1px solid #e9b10e;
            background-color: rgba(233, 177, 14, 0.1);
          }

          .give {
            position: absolute;
            top: 1px;
            left: 0;
            width: 100%;
            height: 32px;
            line-height: 32px;
            margin-left: 1px;
            background-color: #e9b10e;
            color: #1a1c24;
            font-size: 13px;
            text-align: center;
            border-top-right-radius: 5px;
            border-top-left-radius: 5px;
          }
        }

        .list-li {
          // padding: 40px 20px 20px 20px;
        }

        li:hover {
          cursor: pointer;
        }
      }
    }

    .ment-btn {
      margin: 48px 0;
      display: flex;
      justify-content: center;

      .el-btn {
        padding: 14px 26px;
        font-size: 16px;
        color: #1a1c24;
        background-color: #e9b10e;
        border-radius: 5px;
        font-weight: 600;
        border: none;
      }

      /*span:hover {
        cursor: pointer;
      }*/
    }
  }

  .pay-ment /deep/ .el-tabs__item {
    margin-bottom: 6px;
  }

  .pay-ment /deep/ .el-tabs__item.is-active {
    color: #c3c3e2;
  }

  .pay-ment /deep/ .el-tabs__item {
    color: #848492;
    font-size: 20px;
  }

  .el-button--warning {
    background-color: #e9b10e;
    color: #1a1c24;
    font-weight: 600;
  }
}
</style>

<style lang="less">
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-height: 415px;
  min-width: 300px;
  background-color: #333542;
  color: #c3c3e2;
  font-size: 18px;
  line-height: 44px;
}

.el-dialog__header {
  background-color: #333542;
}

.dialog-title {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #333542;

  div {
    display: flex;
    align-items: center;

    img {
      width: 25px;
      margin: 0 16px 0 0;
    }
  }
}

.el-dialog__body {
  flex: 1;
  overflow: auto;
  background-color: #333542;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2b2c37;

  img {
    max-width: 29px;
    max-height: 29px;
    margin-right: 16px;
  }

  div > p {
    font-size: 12px;
    line-height: 16px;
    display: block;
  }
}

.el-dialog__footer {
  background-color: #2b2c37;
}

.save-qrcode {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
}

.img-r0 {
  width: 40% !important;
}

.img-r1 {
  width: 50% !important;
}

.img-r2 {
  width: 60% !important;
}

.img-r3 {
  width: 70% !important;
}

.img-r4 {
  width: 80% !important;
}

.time {
  font-size: 16px;
}

.no-p {
  height: 23px !important;
}

.no-p-1 {
  height: 0 !important;
}

@media screen and (max-width: 767px) {
  .pay .pay-ment .ment-list ul li {
    width: 42% !important;
    // margin: 0 !important;
  }
}
</style>

<style lang="less">
.pk-payment-page {
  min-height: calc(100vh - 198px) !important;
  padding: 32px 28px 96px !important;
  color: #f5f7ff !important;
  overflow: visible !important;
  background:
    radial-gradient(circle at 44% 0, rgba(255, 138, 31, 0.16), transparent 34%),
    radial-gradient(circle at 86% 24%, rgba(0, 217, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #1d202c 0%, #171923 100%) !important;
}

.pk-payment-page .pay-warp {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
  margin: 0 auto !important;
  padding: 0 !important;
}

.pk-payment-page .pay-hint {
  min-height: 282px !important;
  margin: 0 !important;
  padding: 42px 46px !important;
  display: grid !important;
  grid-template-columns: 1fr auto !important;
  gap: 18px 28px !important;
  align-items: start !important;
  position: relative !important;
  overflow: hidden !important;
  text-align: left !important;
  border: 1px solid rgba(255, 132, 31, 0.36) !important;
  border-radius: 22px !important;
  background:
    radial-gradient(ellipse at 78% 46%, rgba(255, 163, 35, 0.2), transparent 44%),
    linear-gradient(135deg, rgba(39, 42, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.pk-payment-page .pay-hint::after {
  content: "" !important;
  width: 560px !important;
  height: 560px !important;
  position: absolute !important;
  right: -160px !important;
  top: -190px !important;
  border-radius: 50% !important;
  background: radial-gradient(circle, rgba(255, 147, 31, 0.32), transparent 66%) !important;
  pointer-events: none !important;
}

.pk-payment-page .pay-hint-left {
  display: block !important;
  position: relative !important;
  z-index: 1 !important;
}

.pk-payment-page .pay-hint-left::before {
  content: "DEPOSIT" !important;
  display: block !important;
  color: #ff8a1f !important;
  font-size: 13px !important;
  font-weight: 900 !important;
  letter-spacing: 0.16em !important;
}

.pk-payment-page .pay-hint-left strong {
  margin: 12px 0 16px !important;
  display: block !important;
  color: #f8fbff !important;
  font-size: 58px !important;
  line-height: 1 !important;
  font-weight: 1000 !important;
}

.pk-payment-page .pay-hint-left span {
  display: block !important;
  max-width: 640px !important;
  color: #aeb6c8 !important;
  font-size: 17px !important;
  line-height: 1.8 !important;
  font-weight: 800 !important;
}

.pk-payment-page .payBill {
  height: 46px !important;
  min-width: 118px !important;
  margin: 0 !important;
  padding: 0 24px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
  z-index: 1 !important;
  color: #151620 !important;
  background: linear-gradient(180deg, #ffcb28, #ff8a00) !important;
  border-radius: 8px !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
  box-shadow: 0 12px 28px rgba(241, 107, 0, 0.28) !important;
}

.pk-payment-page .pay-hint-actions {
  display: inline-flex;
  gap: 10px;
  position: relative;
  z-index: 1;
}

.pk-payment-page .pay-hint-actions > button:first-child {
  height: 46px;
  min-width: 104px;
  padding: 0 18px;
  color: #dbe3f2;
  border: 1px solid rgba(213, 223, 244, .42);
  border-radius: 8px;
  background: rgba(40, 44, 59, .82);
  font-size: 15px;
  font-weight: 900;
  cursor: pointer;
}

.pk-payment-page .tMsg {
  grid-column: 1 / -1 !important;
  max-width: 780px !important;
  position: relative !important;
  z-index: 1 !important;
  color: #9aa3b8 !important;
  font-size: 14px !important;
  line-height: 1.7 !important;
}

.pk-payment-page .tMsg span {
  color: #20d7ef !important;
  font-weight: 900 !important;
}

.pk-payment-page .identity-panel {
  min-height: 106px !important;
  margin-top: 18px !important;
  padding: 18px 22px !important;
  display: grid !important;
  grid-template-columns: 58px minmax(0, 1fr) auto !important;
  gap: 16px !important;
  align-items: center !important;
  border: 1px solid rgba(255, 255, 255, 0.07) !important;
  border-radius: 14px !important;
  background:
    radial-gradient(circle at 8% 50%, rgba(255, 138, 31, 0.12), transparent 26%),
    linear-gradient(180deg, rgba(43, 45, 59, 0.96), rgba(31, 33, 45, 0.98)) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035) !important;
}

.pk-payment-page .identity-mark {
  width: 58px !important;
  height: 58px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #171923 !important;
  background: linear-gradient(145deg, #ffd764, #ff8a00) !important;
  border-radius: 16px 16px 16px 5px !important;
  font-size: 18px !important;
  font-weight: 1000 !important;
  box-shadow: 0 12px 24px rgba(255, 138, 0, 0.2) !important;
}

.pk-payment-page .identity-copy {
  min-width: 0 !important;
}

.pk-payment-page .identity-copy > span {
  color: #7f899f !important;
  font-size: 11px !important;
  font-weight: 1000 !important;
  letter-spacing: 0.12em !important;
}

.pk-payment-page .identity-copy strong {
  margin-left: 12px !important;
  color: #ffd764 !important;
  font-size: 15px !important;
}

.pk-payment-page .identity-copy p,
.pk-payment-page .identity-copy em {
  margin: 7px 0 0 !important;
  display: block !important;
  color: #aeb6c8 !important;
  font-size: 13px !important;
  font-style: normal !important;
  line-height: 1.6 !important;
}

.pk-payment-page .identity-copy em {
  color: #ff8f8f !important;
}

.pk-payment-page .identity-panel > button,
.pk-payment-page .identity-result {
  min-width: 112px !important;
  height: 42px !important;
  padding: 0 18px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #151620 !important;
  background: linear-gradient(180deg, #ffcb28, #ff8a00) !important;
  border: 0 !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  font-weight: 1000 !important;
}

.pk-payment-page .identity-result {
  color: #d2d8e7 !important;
  background: rgba(255, 255, 255, 0.06) !important;
}

.pk-payment-page .identity-panel > .identity-view-button {
  color: #d2d8e7 !important;
  background: rgba(255, 255, 255, 0.06) !important;
}

.pk-payment-page .identity-panel > .identity-view-button:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.pk-payment-page .identity-status-2 {
  border-color: rgba(40, 199, 111, 0.3) !important;
}

.pk-payment-page .identity-status-2 .identity-mark {
  color: #082716 !important;
  background: linear-gradient(145deg, #62e99f, #28c76f) !important;
}

.identity-dialog .el-dialog {
  color: #f4f7ff !important;
  background: #252836 !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 14px !important;
}

.identity-dialog .el-dialog__title {
  color: #f4f7ff !important;
  font-weight: 1000 !important;
}

.identity-form {
  display: grid !important;
  gap: 16px !important;
}

.identity-form > p {
  margin: 0 !important;
  padding: 12px 14px !important;
  color: #aeb6c8 !important;
  background: rgba(255, 138, 0, 0.08) !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  line-height: 1.7 !important;
}

.identity-form label {
  display: grid !important;
  gap: 8px !important;
  color: #cdd3e2 !important;
  font-size: 13px !important;
  font-weight: 900 !important;
}

.identity-form input {
  width: 100% !important;
  height: 44px !important;
  padding: 0 14px !important;
  color: #f4f7ff !important;
  background: #191b25 !important;
  border: 1px solid rgba(255, 255, 255, 0.09) !important;
  border-radius: 8px !important;
  outline: none !important;
}

.identity-form .el-checkbox__label {
  color: #9aa3b8 !important;
  white-space: normal !important;
}

.payment-identity-tools {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 12px !important;
}

.payment-identity-tools button {
  min-width: 116px !important;
  height: 34px !important;
  padding: 0 12px !important;
  color: #ffd56d !important;
  background: rgba(255, 166, 39, 0.08) !important;
  border: 1px solid rgba(255, 184, 74, 0.35) !important;
  border-radius: 7px !important;
  cursor: pointer !important;
}

.identity-detail {
  display: grid !important;
  gap: 16px !important;
}

.identity-detail-status {
  padding: 14px 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  color: #aeb6c8 !important;
  background: rgba(255, 255, 255, 0.04) !important;
  border: 1px solid rgba(255, 255, 255, 0.07) !important;
  border-radius: 10px !important;
}

.identity-detail-status strong {
  color: #ffd764 !important;
}

.identity-detail-status.status-2 strong {
  color: #62e99f !important;
}

.identity-detail-status.status-3 strong {
  color: #ff8f8f !important;
}

.identity-detail dl {
  margin: 0 !important;
  overflow: hidden !important;
  background: #191b25 !important;
  border: 1px solid rgba(255, 255, 255, 0.07) !important;
  border-radius: 10px !important;
}

.identity-detail dl > div {
  min-height: 48px !important;
  padding: 12px 16px !important;
  display: grid !important;
  grid-template-columns: 104px minmax(0, 1fr) !important;
  align-items: center !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;
}

.identity-detail dl > div:last-child {
  border-bottom: 0 !important;
}

.identity-detail dt {
  color: #7f899f !important;
}

.identity-detail dd {
  margin: 0 !important;
  color: #f4f7ff !important;
  text-align: right !important;
  word-break: break-all !important;
}

.pk-payment-page .pay-ment {
  margin-top: 18px !important;
  padding: 22px !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  border-radius: 16px !important;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98)) !important;
  box-shadow:
    0 18px 50px rgba(0, 0, 0, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.035) !important;
}

.pk-payment-page .pay-ment .el-tabs__nav-wrap::after {
  background-color: rgba(255, 255, 255, 0.06) !important;
}

.pk-payment-page .pay-ment .el-tabs__item {
  height: 44px !important;
  padding: 0 22px !important;
  color: #9aa3b8 !important;
  font-size: 14px !important;
  font-weight: 1000 !important;
}

.pk-payment-page .pay-ment .el-tabs__item.is-active {
  color: #ffd764 !important;
}

.pk-payment-page .pay-ment .el-tabs__active-bar {
  height: 3px !important;
  background: linear-gradient(90deg, #ffcb28, #ff8a00) !important;
}

.pk-payment-page .ment-two {
  min-height: 96px !important;
  margin-top: 14px !important;
  padding: 18px 20px !important;
  justify-content: flex-start !important;
  border: 1px solid rgba(111, 121, 151, 0.22) !important;
  border-radius: 12px !important;
  background:
    radial-gradient(circle at 8% 50%, rgba(255, 132, 31, 0.14), transparent 28%),
    #242735 !important;
}

.pk-payment-page .ment-two img {
  width: 50px !important;
  height: 50px !important;
  object-fit: contain !important;
}

.pk-payment-page .ment-two span {
  color: #f4f7ff !important;
  font-size: 24px !important;
  font-weight: 1000 !important;
}

.pk-payment-page .ment-three {
  margin-top: 14px !important;
  padding: 14px 16px !important;
  color: #ffd764 !important;
  text-align: left !important;
  background: rgba(255, 138, 31, 0.08) !important;
  border: 1px solid rgba(255, 138, 31, 0.18) !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  font-weight: 900 !important;
}

.pk-payment-page .gift-card-panel {
  margin-top: 18px !important;
  padding: 20px !important;
  border: 1px solid rgba(255, 138, 31, 0.18) !important;
  border-radius: 12px !important;
  background:
    radial-gradient(circle at 12% 18%, rgba(255, 203, 40, 0.16), transparent 34%),
    #202330 !important;
}

.pk-payment-page .gift-card-panel p {
  margin: 0 !important;
  color: #c2c9da !important;
  font-size: 14px !important;
  font-weight: 800 !important;
  line-height: 1.8 !important;
}

.pk-payment-page .gift-grid {
  margin-top: 18px !important;
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 14px !important;
}

.pk-payment-page .gift-grid label {
  display: grid !important;
  gap: 8px !important;
}

.pk-payment-page .gift-grid span,
.pk-payment-page .gift-note strong {
  color: #ffd764 !important;
  font-size: 13px !important;
  font-weight: 1000 !important;
}

.pk-payment-page .gift-grid input {
  height: 44px !important;
  padding: 0 14px !important;
  color: #f4f7ff !important;
  background: #171923 !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 8px !important;
  outline: none !important;
}

.pk-payment-page .gift-note {
  margin-top: 16px !important;
  padding: 14px 16px !important;
  display: grid !important;
  gap: 6px !important;
  border-radius: 10px !important;
  background: rgba(255, 255, 255, 0.045) !important;
}

.pk-payment-page .gift-note span {
  color: #9aa3b8 !important;
  font-size: 13px !important;
  font-weight: 800 !important;
}

.pk-payment-page .ment-list,
.pk-payment-page .ment-listm {
  margin-top: 18px !important;
  display: block !important;
}

.pk-payment-page .ment-list ul,
.pk-payment-page .ment-listm ul {
  margin: 0 !important;
  padding: 0 !important;
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(176px, 1fr)) !important;
  gap: 14px !important;
  list-style: none !important;
}

.pk-payment-page .ment-list ul li,
.pk-payment-page .ment-listm ul li {
  position: relative !important;
  float: none !important;
  width: auto !important;
  min-height: 258px !important;
  margin: 0 !important;
  padding: 14px !important;
  overflow: hidden !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  border-radius: 12px !important;
  background:
    radial-gradient(ellipse at 50% 42%, rgba(255, 132, 31, 0.14), transparent 58%),
    linear-gradient(180deg, #2b2e3d, #242735) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035) !important;
}

.pk-payment-page .package-name {
  min-height: 20px !important;
  margin: 18px 4px 0 !important;
  overflow: hidden !important;
  color: #f4f7ff !important;
  font-size: 14px !important;
  font-weight: 1000 !important;
  line-height: 20px !important;
  text-align: center !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.pk-payment-page .package-gift {
  position: absolute !important;
  top: 42px !important;
  right: 10px !important;
  z-index: 3 !important;
  padding: 4px 8px !important;
  color: #191923 !important;
  background: linear-gradient(90deg, #ffcb28, #ff8a00) !important;
  border-radius: 12px !important;
  font-size: 11px !important;
  font-weight: 1000 !important;
}

.pk-payment-page .ment-list ul li:hover,
.pk-payment-page .ment-listm ul li:hover {
  border-color: rgba(255, 138, 0, 0.48) !important;
  box-shadow: 0 20px 44px rgba(0, 0, 0, 0.26), 0 0 24px rgba(255, 138, 0, 0.12) !important;
}

.pk-payment-page .ment-list .ment-state,
.pk-payment-page .ment-listm .ment-state {
  border-color: rgba(255, 174, 29, 0.86) !important;
  background: rgba(255, 138, 0, 0.1) !important;
  box-shadow: inset 0 0 0 1px rgba(255, 224, 116, 0.22), 0 0 24px rgba(255, 138, 0, 0.16) !important;
}

.pk-payment-page .ment-list .give,
.pk-payment-page .ment-listm .give {
  height: 30px !important;
  line-height: 30px !important;
  background: linear-gradient(90deg, #ffcb28, #ff8a00) !important;
  color: #151620 !important;
  font-weight: 1000 !important;
}

.pk-payment-page .ment-list .list-top,
.pk-payment-page .ment-listm .list-top {
  width: 116px !important;
  height: 106px !important;
  margin: 18px auto 8px !important;
}

.pk-payment-page .ment-list .list-top img,
.pk-payment-page .ment-listm .list-top img {
  object-fit: contain !important;
  filter: drop-shadow(0 18px 22px rgba(0, 0, 0, 0.42)) !important;
}

.pk-payment-page .ment-list .list-con,
.pk-payment-page .ment-listm .list-con {
  color: #ffd764 !important;
  font-size: 28px !important;
  font-weight: 1000 !important;
}

.pk-payment-page .ment-list .list-con::after,
.pk-payment-page .ment-listm .list-con::after {
  content: "" !important;
  width: 18px !important;
  height: 18px !important;
  margin-left: 6px !important;
  display: inline-block !important;
  vertical-align: -2px !important;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat !important;
}

.pk-payment-page .ment-list .list-bot,
.pk-payment-page .ment-listm .list-bot {
  color: #9aa3b8 !important;
  font-size: 13px !important;
  font-weight: 900 !important;
}

.pk-payment-page .package-desc {
  min-height: 34px !important;
  margin-top: 8px !important;
  overflow: hidden !important;
  color: #7f899f !important;
  display: -webkit-box !important;
  font-size: 11px !important;
  font-weight: 800 !important;
  line-height: 17px !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 2 !important;
}

.pk-payment-page .ment-list .list-top1,
.pk-payment-page .ment-listm .list-top1 {
  height: auto !important;
  margin: 64px auto 18px !important;
  color: #f4f7ff !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
}

.pk-payment-page .ment-list .list-input,
.pk-payment-page .ment-listm .list-input {
  margin-top: 12px !important;
}

.pk-payment-page .ment-list .list-input .el-input__inner,
.pk-payment-page .ment-listm .list-input .el-input__inner {
  color: #ffd764 !important;
  background: #1c1e28 !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
}

.pk-payment-page .ment-btn {
  margin: 24px 0 4px !important;
}

.pk-payment-page .ment-btn .el-btn {
  min-width: 180px !important;
  height: 48px !important;
  padding: 0 28px !important;
  color: #151620 !important;
  background: linear-gradient(180deg, #ffcb28, #ff8a00) !important;
  border: 0 !important;
  border-radius: 8px !important;
  font-size: 15px !important;
  font-weight: 1000 !important;
  box-shadow: 0 14px 30px rgba(241, 107, 0, 0.25) !important;
}

@media screen and (max-width: 900px) {
  .identity-dialog .el-dialog {
    width: calc(100% - 24px) !important;
  }

  .pk-payment-page {
    padding: 20px 12px 72px !important;
  }

  .pk-payment-page .pay-warp {
    width: 100% !important;
  }

  .pk-payment-page .pay-hint {
    grid-template-columns: 1fr !important;
    padding: 30px 22px !important;
  }

  .pk-payment-page .gift-grid {
    grid-template-columns: 1fr !important;
  }

  .pk-payment-page .identity-panel {
    grid-template-columns: 48px minmax(0, 1fr) !important;
    padding: 16px !important;
  }

  .pk-payment-page .identity-mark {
    width: 48px !important;
    height: 48px !important;
  }

  .pk-payment-page .identity-panel > button,
  .pk-payment-page .identity-result {
    grid-column: 1 / -1 !important;
    width: 100% !important;
  }

  .pk-payment-page .pay-hint-left strong {
    font-size: 42px !important;
  }

  .pk-payment-page .ment-list ul,
  .pk-payment-page .ment-listm ul {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

/* 2026-07-05 exact internal pass: recharge page full-width target panels. */
.pk-payment-page {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 24px 96px !important;
  box-sizing: border-box !important;
  background:
    radial-gradient(ellipse at 50% 180px, rgba(255, 138, 31, 0.08), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1d29 420px, #171923 100%) !important;
}

.pk-payment-page .pay-warp,
.pk-payment-page .gift-card-panel,
.pk-payment-page .identity-panel,
.pk-payment-page .payment-records {
  width: 100% !important;
  max-width: none !important;
  box-sizing: border-box !important;
}

.pk-payment-page .pay-hint {
  min-height: 286px !important;
  padding: 32px 38px !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 72% 50%, rgba(255, 138, 31, 0.16), transparent 46%),
    #20222f !important;
  box-shadow: none !important;
}

.pk-payment-page .pay-hint-left strong {
  color: #f4ead8 !important;
  font-size: 54px !important;
}

.pk-payment-page .ment-list,
.pk-payment-page .ment-listm {
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background: #20222f !important;
}

.pk-payment-page .ment-list ul,
.pk-payment-page .ment-listm ul {
  grid-template-columns: repeat(auto-fill, minmax(156px, 1fr)) !important;
  gap: 10px !important;
}

.pk-payment-page .money-list,
.pk-payment-page .money-listm {
  min-height: 104px !important;
  border: 1px solid rgba(67, 73, 96, 0.72) !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 50% 50%, rgba(236, 216, 184, 0.07), transparent 62%),
    #252837 !important;
}

.pk-payment-page .ment-btn .el-btn {
  color: #fff7df !important;
  background: linear-gradient(180deg, #ff971f, #f26b00) !important;
}

.pk-payment-page .pk-payment-channel-status {
  margin: 0 0 18px !important;
  padding: 12px 14px !important;
  color: #c4ccdb !important;
  background: rgba(52, 57, 76, 0.76) !important;
  border: 1px solid rgba(118, 128, 155, 0.22) !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  line-height: 1.65 !important;
}

.pk-payment-page .pk-identity-recharge-lock {
  margin: 0 0 12px !important;
  padding: 12px 14px !important;
  color: #ffd39a !important;
  background: rgba(255, 128, 18, 0.09) !important;
  border: 1px solid rgba(255, 153, 45, 0.42) !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  line-height: 1.65 !important;
}

.pk-payment-page .ment-btn .el-btn.is-disabled,
.pk-payment-page .ment-btn .el-btn.is-disabled:hover {
  color: #d4d9e5 !important;
  background: #5b6070 !important;
  border-color: #5b6070 !important;
  opacity: 1 !important;
}

@media screen and (max-width: 900px) {
}
</style>
